module.exports = __webpack_public_path__ + "img/notification.63c3f137.svg";